(function () {
  /**
   * @ngdoc component
   * @name abxActionButtons
   *
   * @description
   * Component for use with the mobile header
   */
  angular
    .module("akitabox.mobile.components.action-buttons", [
      "akitabox.core.services.identity",
      "akitabox.core.services.organization",
      "akitabox.core.services.redirect",
      "akitabox.core.toast",
    ])
    .controller("ActionButtons", ActionButtonsController)
    .component("abxActionButtons", {
      bindings: {
        menuOpen: "=abxMenuOpen",
        actions: "<abxActions",
      },
      controller: ActionButtonsController,
      controllerAs: "vm",
      templateUrl:
        "app/mobile/components/action-buttons/action-buttons.component.html",
    });

  /* @ngInject */
  function ActionButtonsController() {
    var self = this;

    // Attributes

    // Functions
    self.closeActionMenu = closeActionMenu;

    function closeActionMenu() {
      self.menuOpen = false;
    }
  }
})();
